import {
  BrandsStrip,
  CtaBand,
  FeatureBand,
  Footer,
  Header,
  Hero,
  SegmentsStrip,
  ServicesStrip,
  StatsStrip,
} from '../../molecules'

export function MainTemplate() {
  return (
    <>
      <Header />
      <Hero />
      <StatsStrip />
      <SegmentsStrip />
      <ServicesStrip />
      <FeatureBand />
      <BrandsStrip />
      <CtaBand />
      <Footer />
    </>
  )
}
